import BillingsOrderRailyTaxiDraftRequest from "../../../../../api/raily/billings/order/raily-taxi/draft/billings-order-raily-taxi-draft.request";
import BillingsOrderRailyTaxiDraftParams from "./billings-order-raily-taxi-draft-params";

const createRequest = (
  params: BillingsOrderRailyTaxiDraftParams,
): BillingsOrderRailyTaxiDraftRequest => {
  return {
    orderUuid: params.orderUuid,
  };
};

const billingsOrderRailyTaxiDraftParamsFactory = {
  createRequest,
};

export default billingsOrderRailyTaxiDraftParamsFactory;
